/**
 * Responsive sizing utilities to maintain readability across devices
 */

/**
 * Scale font size proportionally with blocks to prevent text overflow
 * Without scaling, text would break block layouts on tablets where blocks
 * shrink by 30-50% but text stays the same size, causing wrapping/clipping
 */
export const getResponsiveBlockFontSize = (): string => {
	const width = window.innerWidth;

	if (width < 768) {
		// Mobile: 50% scale
		return '0.65rem';
	} else if (width < 1024) {
		// Small Tablet: 60% scale
		return '0.75rem';
	} else if (width < 1366) {
		// Large Tablet: 70% scale
		return '0.875rem';
	}

	// Desktop: 100% scale
	return '1rem';
};

export const getResponsiveDefaultPosition = () => {
	const width = window.innerWidth;

	if (width < 768) {
		return { x: 20, y: 20 };
	}

	return { x: 100, y: 100 };
};
